<template>
  <com-popup v-if="show">
    <section style="max-width:90%;padding:0.98rem 0.74rem;background: #fff;border-radius: 0.32rem;">
      
      <div @click="btnClose" style="width:0.36rem;height:0.36rem;position: absolute;right:0.38rem;top:0.42rem;">
        <img src="@/assets/close.png" full>
      </div>
      
      <h1 color-title>{{title}} </h1>

      <section class="flex-row" style="margin-top:0.45rem">
        <div>
          <h4 color-small-title v-html="textLeft"></h4>
        </div>
        <!-- <div v-if="textRight" style="width:50%;margin-left: 0.18rem;" >
          <h4 color-small-title>{{textRight}}</h4>
        </div> -->
      </section>

    </section>
  </com-popup>
</template>
<script>

import comPopup from '@/components/comPopup';

export default {
  mixins: [],
  name: "com-popup-help",
  computed: {
  },
  data() {
    return {
      title:"",
      textLeft:"",
      textRight:"",
      show:false,
    };
  },
  methods: {
    btnClose(){
      this.show=false;
    },
    open(title,left,right){
      this.title=title;
      this.textLeft=left;
      this.textRight=right;
      this.show=true;
    }
  },
  components: {
    comPopup
  }
};

</script>
<style scoped lang="scss">
</style>
